import SetPassForm from './SetPassForm';
import './style.styl';

export { SetPassForm };
export default SetPassForm;
